export default __webpack_public_path__ + "static/media/gr_logo_mob.829171e7.svg";